import React, { useState } from 'react';
import './FaqAccordion.css';
import faqsData from './faqsData.json';

const ArrowDownIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <rect width="64" height="64" rx="32" fill="var(--bonvoy-coral)"/>
    <path d="M32.0039 22.9999L32.0039 40.4999" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22.8349 31.8312L32.0074 41.0037L41.7343 31.2768" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ArrowUpIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <rect width="64" height="64" rx="32" fill="#D7D2CF"/>
    <path d="M31.9961 41.0001L31.9961 23.5001" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M41.1651 32.1688L31.9926 22.9963L22.2657 32.7232" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const DownloadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 17V3" />
    <path d="M6 11l6 6 6-6" />
    <path d="M19 21H5" />
  </svg>
);

const FaqAccordion = () => {
  const [openIndex, setOpenIndex] = useState(1); // Set second item open by default to match design

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className='faq-accordion-section'>
      <h2>FREQUENTLY ASKED QUESTIONS</h2>
      <div className='faq-list'>
        {faqsData.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div key={idx} className={`faq-item ${isOpen ? 'expanded' : ''}`}>
              <h3 className='faq-item-heading'>
                <button
                  type='button'
                  id={`faq-header-${idx}`}
                  className='faq-item-header'
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${idx}`}
                  onClick={() => toggleAccordion(idx)}
                >
                  <span>{faq.title}</span>
                  <span className={`faq-toggle-btn ${isOpen ? 'open' : ''}`} aria-hidden='true'>
                    {isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
                  </span>
                </button>
              </h3>
              <div
                id={`faq-panel-${idx}`}
                role='region'
                aria-labelledby={`faq-header-${idx}`}
                className={`faq-item-body-wrapper ${isOpen ? 'open' : ''}`}
              >
                <div className='faq-item-body'>
                  <div className='faq-item-body-inner'>
                    {faq.contentTop && <p>{faq.contentTop}</p>}
                    
                    {faq.hasDownload && (
                      <div className='download-box'>
                        <span className='download-title'>{faq.downloadTitle}</span>
                        <span className='download-meta'>{faq.downloadType}</span>
                        <span className='download-size'>{faq.downloadSize}</span>
                        <a href={faq.downloadLink} download className='download-btn'>
                          <DownloadIcon />
                        </a>
                      </div>
                    )}
                    
                    {faq.contentBottom && <p>{faq.contentBottom}</p>}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FaqAccordion;